import React from 'react';
import {VarianceType} from "../../VarianceType";
import {LineMonthData} from './Line';
import "./NumberCells.scss";

interface NumberCellsProps {
    monthNumbers: LineMonthData[];
    total: number;
    referenceTotal: number;
    variance: number;
    variancePercent: number | null;
    isPositiveGood: boolean;
    varianceSelectedValue?: string;
    isReforecast: boolean;
    rowName?: string;
    reforecastStartMonth?: number;
}


export const NumberCells: React.VFC<NumberCellsProps> = (props) => {

    const formatNumber = (value: number) => {
        if (value !== undefined ) {
            if (Number.isNaN(value)) {
                return 0;
            } else {
                return new Intl.NumberFormat().format(Math.round(value));
            }
        }
    };

    function isRfcstStartMonth(monthIndex: number): boolean {
        return props.isReforecast && props.reforecastStartMonth === monthIndex;
    }

    return (
        <>
            {props.monthNumbers.map((mn, index) =>
                <td id={`${props.rowName}-${index + 1}`} key={index} className={`month-values ${props.rowName} ${isRfcstStartMonth(index) && "rfcst-month-start-cell"}`}>
                    {formatNumber(mn.value)}
                </td>
            )}
            <td id={`${props.rowName}-total`} className="as-total"> {formatNumber(props.total)} </td>

            {/* TODO: need to pass data to be able to toggle ACTUALS */}
            <td className="actuals"> {formatNumber(props.referenceTotal)} </td>

            {props.varianceSelectedValue === VarianceType.VARIANCE_AMOUNT ?
                <td className={"variance " + ((!props.isPositiveGood && props.variance < 0) || (props.variance >= 0 && props.isPositiveGood) ? "text-eucalyptus" : "text-roman")}>
                    {formatNumber(props.variance)}
                </td>
                :
                <td className={"variance " + (props.variancePercent === null || (!props.isPositiveGood && props.variancePercent < 0) || (props.isPositiveGood && props.variancePercent >= 0) ? "text-eucalyptus" : "text-roman" )}>
                    {`${props.variancePercent === null ? 'n/a' : Math.abs(props.variancePercent as number) ?? 0}`} %
                </td>
            }
        </>
    );
};


